
import * as THREE from "../../../../libs/three.js/build/three.module.js";

import math from "../../utils/math.js";
import {Utils} from "../../../utils.js"; 

import Tag from '../Tag.js'
 
export class TagTool extends THREE.EventDispatcher{
	constructor (viewer) {
		super();
        this.viewer = viewer
  
        viewer.tags = new THREE.Object3D;
        viewer.scene.overlayScene.add(viewer.tags)
        
        
        
        
        this.viewer.addEventListener('start_inserting_tag', e => {
			this.viewer.dispatchEvent({
				type: 'cancel_insertions'
			});
		});
    }
    
    
    
    
    createTagFromData(data){
        let tag = new Tag(data)
        return tag
        
    }
     
     
    getPoseByIntersect(e){
        if(!e.intersect?.location)return
        let root = e.intersect.pointcloud || e.intersect.object
        let position = Potree.Utils.datasetPosTransform({ toDataset: true,  pointcloud:e.intersect.pointcloud,  object:e.intersect.object,  position:e.intersect.location })
        let normal = e.intersect.localNormal?.clone() 
        if(!normal){
            normal = e.intersect.normal.clone().applyMatrix4(root.rotateInvMatrix) 
        }
        
        return {root,normal,position}
    } 
     
    
    startInsertion (args = {}, callback, cancelFun) {
        let deferred = $.Deferred();
         
        this.viewer.dispatchEvent({
			type: 'start_inserting_tag' 
			 
		});
        this.adding = true
        
        let cancel = ()=>{
            end()
        }
        let end = ()=>{
            this.adding = false
            viewer.dispatchEvent({type:"endTagMove"})
            this.viewer.removeEventListener('global_click', click)
        }
        let click = (e)=>{
             
            let info = this.getPoseByIntersect(e)
            if(!info)return
            info.title = '1' 
            let tag = new Tag(info)  
            end()
            e.consume && e.consume()
            deferred.resolve(tag)
             
            return {stopContinue:true}
            
        }
        this.viewer.addEventListener('global_click', click,  {importance:10})
        return deferred.promise()
    }  
    
    
    
    
    
    
}

